import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import TradesTable from "../trade/TradesTable";
import { getBotConfig, getBotState } from "../utils/botUtils";
import { Accordion, Icon } from "semantic-ui-react";
import BotConfig from "../bot/BotConfig";
import SimStats from "./SimStats";
import ClosedTrades from "./SimClosedTrades";
import SimStatsCandles from "./SimStatsCandles";

@inject("store")
@observer
class Sim extends Component {
  load() {
    const {
      store: { isSimSectionExpanded },
    } = this.props;

    if (this.closedTradesComponent && isSimSectionExpanded("closedTrades")) {
      this.closedTradesComponent.wrappedInstance.load();
    }
  }

  render() {
    const {
      store: { zoneId, isSimSectionExpanded, toggleSimSectionExpanded },
      exchangeType,
      sim,
    } = this.props;

    const state = getBotState(sim);
    const config = getBotConfig(sim);

    return (
      <div>
        <h2>
          {sim.type} {sim.id}
        </h2>
        <Accordion fluid styled>
          <Accordion.Title active={isSimSectionExpanded("config")} onClick={() => toggleSimSectionExpanded("config")}>
            <Icon name="dropdown" />Config
          </Accordion.Title>
          <Accordion.Content active={isSimSectionExpanded("config")}>
            <BotConfig botInstance={sim} />
          </Accordion.Content>

          <Accordion.Title active={isSimSectionExpanded("stats")} onClick={() => toggleSimSectionExpanded("stats")}>
            <Icon name="dropdown" />
            Stats
          </Accordion.Title>
          <Accordion.Content active={isSimSectionExpanded("stats")}>
            {isSimSectionExpanded("stats") && <SimStats sim={sim} />}
          </Accordion.Content>

          <Accordion.Title
            active={isSimSectionExpanded("statsCandles")}
            onClick={() => toggleSimSectionExpanded("statsCandles")}
          >
            <Icon name="dropdown" />
            Candlestick chart stats
          </Accordion.Title>
          <Accordion.Content active={isSimSectionExpanded("statsCandles")}>
            {isSimSectionExpanded("statsCandles") && (
              <SimStatsCandles botInstance={sim} config={config} exchangeType={exchangeType} />
            )}
          </Accordion.Content>

          <Accordion.Title
            active={isSimSectionExpanded("closedTrades")}
            onClick={() => toggleSimSectionExpanded("closedTrades")}
          >
            <Icon name="dropdown" />
            Closed Trades ({sim.closedTradesCount})
          </Accordion.Title>
          <Accordion.Content active={isSimSectionExpanded("closedTrades")}>
            {isSimSectionExpanded("closedTrades") && (
              <ClosedTrades
                key={sim.id}
                ref={i => (this.closedTradesComponent = i)}
                exchangeType={exchangeType}
                simId={sim.id}
                botConfig={config}
              />
            )}
          </Accordion.Content>

          <Accordion.Title
            active={isSimSectionExpanded("openTrades")}
            onClick={() => toggleSimSectionExpanded("openTrades")}
          >
            <Icon name="dropdown" />
            Open Trades ({state.tradeList && state.tradeList.length})
          </Accordion.Title>
          <Accordion.Content active={isSimSectionExpanded("openTrades")}>
            <TradesTable
              botConfig={config}
              exchangeType={exchangeType}
              trades={state.tradeList && state.tradeList.slice().reverse()}
              zoneId={zoneId}
            />
          </Accordion.Content>
        </Accordion>
      </div>
    );
  }
}

export default Sim;



// WEBPACK FOOTER //
// ./src/sim/Sim.js